"use client";
import NewInGif from "@/assets/gif/newIn.gif";
import NewIn from "@/assets/icons/newIn.svg";
import BestsellerGif from "@/assets/gif/bestSeller.gif";
import BestSeller from "@/assets/icons/bestSeller.svg";
import CelebChoiceGif from "@/assets/gif/celebChoice.gif";
import CelebChoice from "@/assets/icons/celebChoice.svg";
import EssentialsGif from "@/assets/gif/essentials.gif";
import Essentials from "@/assets/icons/essentials.svg";
import TrendingGif from "@/assets/gif/trending.gif";
import Trending from "@/assets/icons/trending.svg";
import AiGlassesGif from "@/assets/gif/aiGlasses.gif";
import AiGlasses from "@/assets/icons/aiGlasses.svg";
import { cn } from "@/lib/tailwind";
import Image, { StaticImageData } from "next/image";
import { useEffect, useRef, useState } from "react";
import Icon from "../ui/icon/Icon";
import RenderCurrencyInText from "../common/RenderCurrencyInText";

type variantType =
  | "text"
  | "Trending"
  | "Bestseller"
  | "New In"
  | "Celeb Choice"
  | "Essentials"
  | "AI Glasses"
  | "outOfStock";

const arabicToEnglishMap: Record<string, variantType> = {
  رائج: "Trending",
  "الأكثر مبيعاً": "Bestseller",
  جديد: "New In",
  "نظارات الذكاء الاصطناع": "AI Glasses",
  "اختيارات النخبة": "Celeb Choice",
  الأساسيات: "Essentials",
};

const variantToIconMap: Record<
  variantType,
  { icon: string; gif: StaticImageData } | null
> = {
  text: null,
  Trending: {
    icon: Trending,
    gif: TrendingGif,
  },
  Bestseller: {
    icon: BestSeller,
    gif: BestsellerGif,
  },
  "New In": {
    icon: NewIn,
    gif: NewInGif,
  },
  Essentials: {
    icon: Essentials,
    gif: EssentialsGif,
  },
  "Celeb Choice": {
    icon: CelebChoice,
    gif: CelebChoiceGif,
  },
  "AI Glasses": {
    icon: AiGlasses,
    gif: AiGlassesGif,
  },
  outOfStock: null,
};
export interface IProductBadgeProps {
  variant: variantType;
  title: string;
  containerClass?: string;
  isPdpScreen?: boolean;
}

const ProductBadge = ({
  title,
  variant,
  containerClass,
  isPdpScreen,
}: IProductBadgeProps) => {
  const [showGif, setShowGif] = useState(true);
  const ref = useRef(null);

  // const path = usePathname();
  const handleGif = () => {
    // if (isInHomePage(path)) {
    setTimeout(() => {
      setShowGif(false);
    }, 6000);
    // }
  };

  const normalizedVariant: variantType =
    arabicToEnglishMap[variant] || (variant as variantType);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowGif(true);
          }
        });
      },
      { root: null, rootMargin: "0px 0px -50% 0px", threshold: 1 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    title !== "" && (
      <div
        ref={ref}
        className={cn(
          "justify inline-flex items-center overflow-hidden bg-primary-4 px-1.5 py-1",
          containerClass,
          // variant === "outOfStock" ? "bg-primary-3 text-white" : "bg-primary-4 text-black",
          normalizedVariant === "outOfStock"
            ? "bg-primary-3 text-white"
            : normalizedVariant in variantToIconMap
            ? "bg-primary-4 text-black"
            : "bg-primary-2 text-[#3A3A3A]",
          isPdpScreen ? "h-[22px] md:h-[24px]" : "h-[18px] md:h-[21px]"
        )}
      >
        <span className="whitespace-nowrap text-[0.75rem] font-semibold text-[#3A3A3A]">
          <RenderCurrencyInText text={title} />
        </span>
        {normalizedVariant &&
          variantToIconMap[normalizedVariant] &&
          normalizedVariant != "text" &&
          normalizedVariant !== "outOfStock" &&
          (showGif ? (
            // <div className="max-w-[1.5rem] overflow-hidden transition-opacity ">
            // <div className="relative flex h-[5rem] w-[5rem] items-center justify-center ">
            <Image
              src={variantToIconMap[normalizedVariant]?.gif ?? ""}
              alt={title}
              width={65}
              height={65}
              // If there is no static icon for the variant, keep the GIF running
              onLoad={
                variantToIconMap[normalizedVariant]?.icon
                  ? handleGif
                  : undefined
              }
              className={cn("py-[5px] px-[2px] h-7 w-[23px]")}
            />
          ) : // </div>
          // </div>
          variantToIconMap[normalizedVariant]?.icon ? (
            <Icon
              src={variantToIconMap[normalizedVariant]?.icon ?? ""}
              title={title}
              size={23}
              imgProps={{ height: 24, width: 24 }}
              classname="transition-opacity ease-out py-[3px] px-1"
            />
          ) : null)}
      </div>
    )
  );
};

export default ProductBadge;
